import Button from "./Button";

export function SchemeDealsButton({ onClick, disabled = false }) {
  return (
    <Button
      type="basic"
      label="New scheme deal"
      size="small"
      disabled={disabled}
      loading={false}
      stretch={false}
      center={true}
      onClick={onClick}
    />
  );
}
